import React from 'react';

import css from './HeaderBar.module.css';
import SunIcon from './images/sun-icon.png';
import MoonIcon from './images/moon-icon.png';

const HeaderBar = props => {
  const { currentUser } = props;

  const userFirstName = currentUser?.attributes?.profile?.firstName;

  const getWelcomeMessage = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return (
        <div className={css.row}>
          <span className={css.welcome}>
            Good morning, <span className={css.name}>{userFirstName}</span>
          </span>

          <img className={css.welcomeIcon} src={SunIcon} />
        </div>
      );
    } else if (currentHour >= 12 && currentHour < 17) {
      return (
        <div className={css.row}>
          <span className={css.welcome}>
            Good afternoon, <span className={css.name}>{userFirstName}</span>
          </span>

          <img className={css.welcomeIcon} src={SunIcon} />
        </div>
      );
    } else if (currentHour >= 17) {
      return (
        <div className={css.row}>
          <span className={css.welcome}>
            Good evening, <span className={css.name}>{userFirstName}</span>
          </span>

          <img className={css.welcomeIcon} src={MoonIcon} />
        </div>
      );
    }
  };

  const getQuoteOfTheDay = () => {
    const quotes = [
      'The best way to predict the future is to create it.',
      "Believe you can and you're halfway there.",
      'It does not matter how slowly you go as long as you do not stop.',
      'We become what we think about.',
      'The only way to do great work is to love what you do.',
      'Change your thoughts and you change your world.',
      'A person who never made a mistake never tried anything new.',
      'The only limit to our realization of tomorrow will be our doubts of today.',
      'What you get by achieving your goals is not as important as what you become by achieving your goals.',
      'Life is 10% what happens to us and 90% how we react to it.',
      'The mind is everything. What you think you become.',
      'An unexamined life is not worth living.',
      'Eighty percent of success is showing up.',
      "Your time is limited, don't waste it living someone else's life.",
      'Strive not to be a success, but rather to be of value.',
    ];

    return quotes[Math.floor(Math.random() * quotes.length)];
  };
  const headerMessage = getWelcomeMessage();
  const quoteMessage = getQuoteOfTheDay();

  return (
    <div className={css.root}>
      <div className={css.col}>
        <div div className={css.row}>
          {headerMessage}
        </div>

        <span className={css.quote}>{quoteMessage}</span>
      </div>
    </div>
  );
};

export default HeaderBar;
